import { useSelector, useDispatch } from "react-redux";
import { selectConstants, updateConstant } from "../configurationsSlice";

const useConstants = (configurationId) => {
  const dispatch = useDispatch();
  const constants = useSelector(selectConstants(configurationId));

  const constantsArray = Object.keys(constants).map((constantKey) => ({
    id: constantKey,
    ...constants[constantKey],
  }));

  const onConstantsChange = (data) => {
    const newValue = parseFloat(data.value);
    dispatch(
      updateConstant({
        configurationId,
        constantId: data.id,
        value:
          newValue >= 0 && newValue.toString() === data.value
            ? newValue
            : newValue < 0
            ? newValue
            : "",
      }),
    );
  };

  return { constantsArray, onConstantsChange };
};

export default useConstants;
